import { render, staticRenderFns } from "./politics.vue?vue&type=template&id=7fa4cc3e&"
import script from "./politics.vue?vue&type=script&lang=js&"
export * from "./politics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports